import {Card} from './Card'

function compareCards(min: Card, max: Card, trump: Card): boolean {
    if (max.suit === min.suit) {
        return max.weight() > min.weight()
    } else {
        return max.suit === trump.suit
    }
}

export default compareCards
